/**
 * O que faz: Busca presets globais de campanhas de follow-up.
 * Onde usa: PresetPicker e wizard de criação de campanhas.
 * Conexões: Supabase client e React Query.
 * Tabelas: follow_up_campaigns (SELECT) e follow_up_templates (SELECT via relação).
 * Autor: IA
 * Data: 23/04/2026
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { FollowupCampaign } from '@/types/followup';

export const useFollowupPresets = () => {
  return useQuery({
    queryKey: ['followup-presets'],
    queryFn: async (): Promise<FollowupCampaign[]> => {
      // Tabela: follow_up_campaigns
      // Operação: SELECT
      // Campos afetados: nenhum; lê presets e templates para pré-preencher o wizard.
      // Filtros: is_preset=true para separar dados globais das campanhas da clínica.
      // Riscos: presets são globais e não contêm dados sensíveis de leads.
      const { data, error } = await (supabase as any)
        .from('follow_up_campaigns')
        .select('*, follow_up_templates(*)')
        .eq('is_preset', true)
        .order('preset_categoria', { ascending: true })
        .order('nome', { ascending: true });

      if (error) {
        throw new Error(`Erro ao buscar presets de follow-up: ${error.message}`);
      }

      return (data ?? []) as FollowupCampaign[];
    },
    staleTime: 5 * 60 * 1000,
  });
};
